import { render, staticRenderFns } from "./safetyVR.vue?vue&type=template&id=50668471&scoped=true"
var script = {}
import style0 from "./safetyVR.vue?vue&type=style&index=0&id=50668471&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50668471",
  null
  
)

export default component.exports